import React, { useEffect, useState } from 'react';
import Header from './Header';
import API_URL from '../config';

function ControlePage({ empresa, usuario, onVoltar, onSair }) {
  const [controles, setControles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [modalAberto, setModalAberto] = useState(false);
  const [form, setForm] = useState({ id: null, tabela: '', sequencia: 0 });
  const [editando, setEditando] = useState(false);
  const [pesquisa, setPesquisa] = useState('');
  const [confirmarExclusao, setConfirmarExclusao] = useState({ aberto: false, id: null });

  const fetchControles = async () => {
    setLoading(true);
    setErro('');
    try {
      const res = await fetch(`${API_URL}/controle?empresa_id=${empresa.id}`);
      const data = await res.json();
      setControles(Array.isArray(data) ? data : []);
    } catch (err) {
      setErro('Erro ao buscar controles');
      setControles([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchControles();
    // eslint-disable-next-line
  }, [empresa.id]);

  const abrirModal = (controle = null) => {
    if (controle) {
      setForm({ ...controle });
      setEditando(true);
    } else {
      setForm({ id: null, tabela: '', sequencia: 0 });
      setEditando(false);
    }
    setErro('');
    setModalAberto(true);
  };

  const fecharModal = () => {
    setModalAberto(false);
    setForm({ id: null, tabela: '', sequencia: 0 });
    setEditando(false);
    setErro('');
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: name === 'sequencia' ? Number(value) : value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setErro('');
    if (!form.tabela) {
      setErro('Preencha o campo Tabela!');
      return;
    }
    try {
      const method = editando ? 'PUT' : 'POST';
      const url = editando ? `${API_URL}/controle/${form.id}` : `${API_URL}/controle`;
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          empresa_id: empresa.id,
          tabela: form.tabela,
          sequencia: Number(form.sequencia) || 0
        })
      });
      if (!res.ok) throw new Error('Erro ao salvar controle');
      fecharModal();
      fetchControles();
    } catch (err) {
      setErro('Erro ao salvar controle');
    }
  };

  const handleDelete = async id => {
    setConfirmarExclusao({ aberto: true, id });
  };

  const confirmarRemocao = async () => {
    try {
      await fetch(`${API_URL}/controle/${confirmarExclusao.id}`, { method: 'DELETE' });
      fetchControles();
    } catch {
      setErro('Erro ao remover controle');
    }
    setConfirmarExclusao({ aberto: false, id: null });
  };

  const cancelarRemocao = () => {
    setConfirmarExclusao({ aberto: false, id: null });
  };

  // Filtro de pesquisa
  const controlesFiltrados = Array.isArray(controles) ? controles.filter(c =>
    c.tabela && c.tabela.toLowerCase().includes(pesquisa.toLowerCase())
  ) : [];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
      <Header usuario={usuario} empresa={empresa} onVoltar={onVoltar} onSair={onSair} />
      <div className="max-w-5xl mx-auto mt-10 bg-white rounded-lg shadow-lg p-6 relative">
        <h2 className="text-2xl font-bold text-blue-700 mb-6">Controle de Sequências</h2>
        <div className="mb-6 flex justify-end">
          <input
            type="text"
            value={pesquisa}
            onChange={e => setPesquisa(e.target.value)}
            placeholder="Pesquisar por tabela..."
            className="border rounded px-3 py-2 w-full max-w-xs"
          />
        </div>
        {erro && <div className="text-red-600 mb-4">{erro}</div>}
        {loading ? (
          <div>Carregando...</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {controlesFiltrados.map(c => (
              <div key={c.id} className="bg-blue-50 rounded-lg shadow flex flex-col p-4 relative border border-blue-200">
                <div className="flex items-center justify-between mb-2">
                  <span className="font-bold text-blue-800 text-lg">{c.tabela}</span>
                  <div className="flex space-x-2">
                    <button onClick={() => abrirModal(c)} title="Editar" className="text-blue-600 hover:text-blue-900">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536M9 13l6-6 3 3-6 6H9v-3z" /></svg>
                    </button>
                    <button onClick={() => handleDelete(c.id)} title="Excluir" className="text-red-600 hover:text-red-900">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                    </button>
                  </div>
                </div>
                <div className="text-gray-700 mb-1"><b>Sequência:</b> {c.sequencia}</div>
                <div className="text-gray-700 mb-1"><b>ID:</b> {c.id}</div>
              </div>
            ))}
            {controlesFiltrados.length === 0 && (
              <div className="col-span-full text-center py-8 text-gray-500">Nenhum controle encontrado.</div>
            )}
          </div>
        )}
        {/* Botão flutuante adicionar */}
        <button
          onClick={() => abrirModal()}
          className="fixed bottom-8 right-8 bg-blue-600 text-white rounded-full shadow-lg w-16 h-16 flex items-center justify-center text-3xl hover:bg-blue-700 transition z-50"
          title="Adicionar Controle"
        >
          +
        </button>
        {/* Modal */}
        {modalAberto && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md relative">
              <button onClick={fecharModal} className="absolute top-2 right-2 text-gray-400 hover:text-red-600 text-2xl">&times;</button>
              <h3 className="text-xl font-bold text-blue-700 mb-4">{editando ? 'Editar Controle' : 'Novo Controle'}</h3>
              <form onSubmit={handleSubmit} className="space-y-3">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Tabela*</label>
                  <input name="tabela" value={form.tabela} onChange={handleChange} className="border rounded px-3 py-2 w-full" required maxLength={50} />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Sequência*</label>
                  <input name="sequencia" type="number" value={form.sequencia} onChange={handleChange} className="border rounded px-3 py-2 w-full" required min={0} />
                </div>
                {erro && <div className="text-red-600 mb-2">{erro}</div>}
                <div className="flex justify-end space-x-2">
                  <button type="button" onClick={fecharModal} className="border border-blue-600 text-blue-600 px-4 py-2 rounded hover:bg-blue-50 transition">Cancelar</button>
                  <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition">{editando ? 'Salvar' : 'Cadastrar'}</button>
                </div>
              </form>
            </div>
          </div>
        )}
        {/* Modal de confirmação de exclusão */}
        {confirmarExclusao.aberto && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-sm relative">
              <h3 className="text-lg font-bold text-red-700 mb-4">Confirmar exclusão?</h3>
              <p className="mb-4">Tem certeza que deseja remover este controle?</p>
              <div className="flex justify-end space-x-2">
                <button onClick={cancelarRemocao} className="border border-blue-600 text-blue-600 px-4 py-2 rounded hover:bg-blue-50 transition">Cancelar</button>
                <button onClick={confirmarRemocao} className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition">Remover</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ControlePage; 